import { CdkMenuModule, CdkMenuTrigger } from '@angular/cdk/menu';
import { OverlayContainer } from '@angular/cdk/overlay';
import { Component, inject, input, InputSignal, signal, Signal, viewChild, WritableSignal, ChangeDetectionStrategy } from '@angular/core';

import { NavItemModel } from '@libs/shared/models';

import { MenuItemComponent } from '../menu-item';

@Component({
  selector: 'ui-hover-menu',
  templateUrl: './hover-menu.component.html',
  styleUrl: 'hover-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CdkMenuModule,
    MenuItemComponent,
  ],
})
export class HoverMenuComponent {
  private readonly overlayContainer: OverlayContainer = inject(OverlayContainer);

  public navItems: InputSignal<readonly NavItemModel[]> = input.required();
  public cdkTrigger: Signal<CdkMenuTrigger> = viewChild.required(CdkMenuTrigger);
  public buttonHovered: WritableSignal<boolean> = signal(false);
  public menuHovered: WritableSignal<boolean> = signal(false);

  public openMenu(): void {
    this.cdkTrigger().open();
  }

  public closeMenu(): void {
    this.cdkTrigger().close();
  }

  public toggleMenu(): void {
    this.cdkTrigger().toggle();
  }

  public touch(): void {
    this.toggleMenu();
  }

  public mouseEnter(): void {
    this.buttonHovered.set(true);
    this.openMenu();
    this.addMenuPanelListeners();
  }

  public mouseLeave(): void {
    this.buttonHovered.set(false);
    this.closeIfNothingHovered();
  }

  public menuOver(): void {
    this.menuHovered.set(true);
  }

  public menuLeave(): void {
    this.menuHovered.set(false);
    this.closeIfNothingHovered();
  }

  private closeIfNothingHovered(): void {
    setTimeout(() => {
      if (!this.menuHovered() && !this.buttonHovered()) {
        this.closeMenu();
      }
    }, 220);
  }

  private getMenuPanelContainer(): HTMLElement | null | undefined {
    return this.overlayContainer.getContainerElement().querySelector('.cdk-menu');
  }

  private addMenuPanelListeners(): void {
    const panel: HTMLElement | null | undefined = this.getMenuPanelContainer();

    if (panel) {
      panel.onmouseover = this.menuOver.bind(this);
      panel.onmouseleave = this.menuLeave.bind(this);
    }
  }
}
